import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    modalShow: false,
    modalTitle: '',
    modalData: [],
    tableCols: [],
    modalLoading: false
};

export const glassDataModalSlice = createSlice({
    name: 'glassDataModal',
    initialState,
    reducers: {
        openModal: (state, action) => {
            const { modalTitle = '', modalData = [], tableCols = [], modalLoading = false } = action.payload || {};
            state.modalShow = true;
            state.modalTitle = modalTitle;
            state.modalData = modalData;
            state.tableCols = tableCols,
                state.modalLoading = modalLoading;
        },
        closeModal: (state) => {
            state.modalShow = false;
            state.modalTitle = '';
            state.modalData = [];
            state.tableCols = [];
            state.modalLoading = false;
        }
    }
});

// Action creators are generated for each case reducer function
export const { openModal, closeModal } = glassDataModalSlice.actions;

export default glassDataModalSlice.reducer;